/**
 * Tokens visuais da extensão de plano.
 *
 * O projeto não tem arquivo de design system: as cores vivem inline em cada
 * componente. Os valores abaixo são os já praticados no frontend — levantados
 * por frequência de uso em `src/**` e conferidos contra
 * `styles/themes/theme-list.ts`, `v2/components/Stepper/styled.ts` e
 * `v2/pages/MissingDataFormulary/styled.ts` — reunidos aqui para o formulário
 * não inventar paleta nova.
 */

/** Marca Conducco (`conduccoThemeSetup.main`). */
const BRAND = "#3024E1";

export const COLORS = {
  brand: BRAND,
  /** Fundo do chip/estado ativo do Stepper. */
  brandSoft: "#E9E6FB",
  /** Texto sobre `brandSoft`. */
  brandInk: "#2F2CEE",
  /** Fundo de destaque suave (cards selecionados). */
  brandTint: "#F7F7FE",

  /** Títulos e rótulos. */
  ink: "#191C1A",
  /** Texto forte alternativo, usado no wordmark e nos ícones. */
  inkStrong: "#0F0F1E",
  /** Texto de apoio. */
  inkMuted: "#6F6F78",
  /** Texto desabilitado / itens excluídos da revisão. */
  inkDisabled: "#8C9097",

  border: "#E8E8E8",
  borderStrong: "#D1D3D4",
  surface: "#FFFFFF",
  canvas: "#FAFAFA",
  /** Fundo neutro dos containers de ícone e linhas inertes. */
  neutralSoft: "#F3F4F6",

  /** MUI success.dark — check de anexo enviado e valores confirmados. */
  success: "#2E7D32",
  successSoft: "#EDF7ED",
  successInk: "#1E4620",

  /** MUI warning.dark — "Atualização necessária". */
  warning: "#EF6C00",
  warningSoft: "#FFF4E5",
  warningInk: "#663C00",

  /** MUI info.main — Alerts informativos. */
  info: "#0288D1",
  infoSoft: "#E5F6FD",
  infoInk: "#014361",

  /** `palette.error.main` do tema. */
  error: "#BA1A1A",
  errorSoft: "#FDEDED",
  errorInk: "#5F2120",
} as const;

/**
 * Breakpoint único do formulário. O spec desenha em 412 (mobile) e 1440 (web);
 * 768px é o ponto em que o layout de duas colunas deixa de caber.
 */
export const MOBILE_BREAKPOINT = "768px";

export const MOBILE_MEDIA_QUERY = `@media screen and (max-width: ${MOBILE_BREAKPOINT})`;

/** Largura útil do card nos passos do wizard (Steps 1 a 5). */
export const CARD_MAX_WIDTH = "1152px";

/**
 * Largura do card no Step 0 e nas telas finais. No Figma essas telas são
 * estreitas e centradas — só o wizard ocupa a largura cheia.
 */
export const CARD_NARROW_MAX_WIDTH = "560px";
